import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Badge } from "@/shared/ui/badge";
import { Progress } from "@/shared/ui/progress";
import { Factory } from "lucide-react";

export function ProductionByLineWidget() {
  const lines = [
    { name: "Assembly Line 1", status: "running", progress: 94, target: 1200, current: 1128, efficiency: 94 },
    { name: "Assembly Line 2", status: "stopped", progress: 0, target: 1200, current: 856, efficiency: 71 },
    { name: "Paint Shop 1", status: "running", progress: 98, target: 800, current: 784, efficiency: 98 },
    { name: "Welding Station A", status: "running", progress: 87, target: 600, current: 522, efficiency: 87 },
    { name: "Final Inspection", status: "running", progress: 92, target: 1000, current: 920, efficiency: 92 },
  ];

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "running":
        return <Badge className="bg-success hover:bg-success/90 text-xs">Running</Badge>;
      case "stopped":
        return <Badge variant="destructive" className="text-xs">Stopped</Badge>;
      case "maintenance":
        return <Badge variant="outline" className="text-xs text-warning border-warning">Maintenance</Badge>;
      default:
        return <Badge variant="outline" className="text-xs">Unknown</Badge>;
    }
  };

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Factory className="h-4 w-4" />
          Production by Line
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-4">
        {lines.map((line) => (
          <div key={line.name} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium">{line.name}</span>
                {getStatusBadge(line.status)}
              </div>
              <span className="text-xs text-muted-foreground">
                {line.current} / {line.target} units
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Progress value={line.progress} className="h-2 flex-1" />
              <span
                className={`text-sm font-bold w-12 text-right ${
                  line.efficiency >= 90 ? "text-success" : line.efficiency >= 75 ? "text-warning" : "text-destructive"
                }`}
              >
                {line.efficiency}%
              </span>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
